// extracted by mini-css-extract-plugin
export default {"link":"IconLink_link__n7N2v","icon":"IconLink_icon__Owla3","xTranslate":"IconLink_xTranslate__gU+qV","yTranslate":"IconLink_yTranslate__quJ+g"};